<div role="document" class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h2 id="prep-file-heading">Créer une Zone</h2>
    </div>
    <div class="modal-body">
      <div class="modal-body">
        <form class="col-10" name="userCreateForm" role="form" novalidate #f="ngForm" (ngSubmit)="valid(f.form) && onSubmit()"
            [formGroup]="userCreateForm">
            <ng-container *ngIf="this.authenSer.isSupperAdmin">
              <div class="form-group ">Saisissez un tenant :
              <ng-select name="selectedVar" dropdownPosition='bottom' formControlName="tenantId" [items]="tenants"
                [ngClass]="{ 'forminput-invalid':f.submitted && userCreateForm?.controls?.customerId?.errors }"
                placeHolder="Tenant" [multiple]="false" [bindLabel]="'companyName'" [closeOnSelect]="true"
                bindValue="id" [clearable]="false">
              </ng-select>
            </div>
            </ng-container>

            <div class="form-group mb-2">
                <label for="label">Label</label>
                <input type="text" class="form-control" id="label" name="label" [ngClass]="{ 'forminput-invalid':
                f.submitted && userCreateForm?.controls?.label?.errors != null}" formControlName="label"/>
                <div *ngIf="f.submitted && userCreateForm?.controls?.label?.errors" class="text-danger">
                  champ Obligatoire
                </div>
            </div>
            <div class="form-group mb-2">Places
              <ng-select  class="mb-2" [ngModelOptions]="{standalone: true}" dropdownPosition='bottom'
                placeholder="" [items]="lstplace" [multiple]="true"
                [closeOnSelect]="false" [bindLabel]="'label'"
                bindValue="id" [(ngModel)]="selectedPlaces" name="selectedPlaces">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  {{item.label}}
                </ng-template>
              </ng-select>
            </div>
            <div class="form-group mb-2">
              <section class="example-section">
                <mat-slide-toggle
                    class="example-margin"
                    formControlName= "active" > Actif
                </mat-slide-toggle>
              </section>
            </div>
            <div class="m-2">
                <button type="button" id="cancel-save" class="btn btn-secondary" data-dismiss="modal"
                    (click)="close();">
                    &nbsp;<span>Annuler</span>
                </button>

                &nbsp;&nbsp;
                <button type="submit" id="save-entity" class="btn btn-indigo button titre">
                    &nbsp;<span>Valider</span>
                </button>
            </div>
        </form>
    </div>
</div>
</div>
